import { Description, HeadingContent, Wrapper } from '../Banners.styles';

export default function ExclusivePreviewBanner() {
  return (
    <Wrapper>
      <HeadingContent>Exclusive preview is ready</HeadingContent>
      <Description>
        You have 48 hours to review and purchase. After that, this vehicle will
        become available to others.
      </Description>
    </Wrapper>
  );
}
